<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
		<g id="Group_47654" data-name="Group 47654" transform="translate(-542 -774)">
			<g id="Ellipse_858" data-name="Ellipse 858" transform="translate(542 774)" fill="#fff8f2" stroke="#f79836" stroke-width="1.5">
				<circle cx="14" cy="14" r="14" stroke="none" />
				<circle cx="14" cy="14" r="13.25" fill="none" />
			</g>
			<path
				id="Path_19471"
				data-name="Path 19471"
				d="M694.246,394.875a1.226,1.226,0,0,1-1.226-1.226v-6.973a1.226,1.226,0,1,1,2.452,0v6.978a1.226,1.226,0,0,1-1.226,1.221Z"
				transform="translate(-138.02 396.096)"
				fill="#f79836"
			/>
			<path
				id="Path_19472"
				data-name="Path 19472"
				d="M694.246,394.3a1.226,1.226,0,0,1-.865-2.094,1.012,1.012,0,0,1,.391-.26,1.224,1.224,0,1,1,.474,2.354Z"
				transform="translate(-138.021 400.158)"
				fill="#f79836"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'SubflowWarningSvg',
};
</script>
